export default __webpack_public_path__ + "static/media/cc2021 (2).310a7f92.jpg";